import { Alert as MuiAlert, AlertTitle, Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

import SwitchElements from 'components/Reporting/Overview/ShareDashboard/SwitchElements'

type Copyclick = {
  placeholder: string
}
type Props = {
  handleCopyClick: ({ placeholder }: Copyclick) => void
  handleSwitchUpdate: (e: any) => void
  handleClickShowPassword: () => void
  values: any
  loader: any
}

const ContentDetails = ({
  handleCopyClick,
  handleSwitchUpdate,
  handleClickShowPassword,
  values,
  loader,
}: Props) => {
  const { t } = useTranslation()

  const { linkSwitch, passwordSwitch } = values

  const data = [
    {
      title: t('reporting.shareDetails.link'),
      onChange: handleSwitchUpdate,
      toggleTitle: t('reporting.shareDetails.sharedLink'),
      content: [
        t('reporting.shareDetails.sharedLinkDetailsOne'),
        t('reporting.shareDetails.sharedLinkDetailsTwo'),
      ],
      disabledContent: [t('reporting.shareDetails.linkTurnedOff')],
      placeholder: 'link',
      checked: linkSwitch,
    },

    linkSwitch && {
      title: t('reporting.shareDetails.password'),
      onChange: handleSwitchUpdate,
      toggleTitle: t('reporting.shareDetails.passwordProtection'),
      content: [
        t('reporting.shareDetails.passwordDetailsOne'),
        t('reporting.shareDetails.passwordDetailsTwo'),
      ],
      placeholder: 'password',
      checked: passwordSwitch,
    },
  ].filter((n) => n)

  const createLinkData = () => {
    return data.map((item) => {
      const switchName = values[`${item.placeholder}Switch`]
      const switchElementProps = {
        switchName,
        t,
        values,
        loader,
        handleClickShowPassword,
        handleCopyClick,
        ...item,
      }
      return <SwitchElements key={item.placeholder} {...switchElementProps} />
    })
  }
  return (
    <>
      <Box>{createLinkData()}</Box>

      <Box>
        <MuiAlert severity="info">
          {linkSwitch ? (
            <>
              <AlertTitle>
                {t('reporting.shareDetails.linkPermissionTitle')}
              </AlertTitle>
              {t('reporting.shareDetails.permissionDetails')}
            </>
          ) : (
            t('reporting.shareDetails.disabledLinkMsg')
          )}
        </MuiAlert>
      </Box>
    </>
  )
}

export default ContentDetails
